// "Recommended for you" homepage strip — hits /api/me/recommendations when logged in.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ListingCard } from '@/components/ListingCard';
import { growth } from '@/lib/growth';
import { useAuth } from '@/contexts/AuthContext';

export const RecommendedForYou = () => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || !user.user_id) { setLoading(false); return; }
    growth.recommend()
      .then((d) => setItems((d.items || []).slice(0, 6)))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user]);

  if (!user || !user.user_id) return null;
  if (loading) return null;

  if (!items.length) {
    return (
      <section className="py-12 bg-gradient-to-r from-emerald-50 to-emerald-100" data-testid="dna-cta">
        <div className="mx-auto max-w-5xl px-4 text-center">
          <Sparkles className="w-8 h-8 mx-auto text-emerald-600 mb-2" />
          <h2 className="font-heading text-2xl font-bold text-gray-900">Unlock personalized recommendations</h2>
          <p className="text-gray-600 mt-1">Take the 30-second Tourist DNA Match quiz.</p>
          <Button variant="green" className="mt-4" asChild><Link to="/dna-quiz" data-testid="dna-cta-start">Start quiz</Link></Button>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 bg-white" data-testid="recommended-for-you">
      <div className="mx-auto max-w-7xl px-4">
        <div className="flex items-end justify-between mb-6">
          <div>
            <div className="text-xs uppercase tracking-wider text-emerald-600 flex items-center gap-1"><Sparkles className="w-3.5 h-3.5" /> Tourist DNA Match</div>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold text-gray-900">Recommended for you, {user.name?.split(' ')[0]}</h2>
          </div>
          <Link to="/recommendations" className="text-sm text-emerald-700 hover:underline flex items-center gap-1">See all <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map(l => <ListingCard key={l.id} listing={l} />)}
        </div>
      </div>
    </section>
  );
};
